'use strict';

const timeFilter = require('../../../../../../utils/timestamp-util').timestampToDateFilter;

const RATE = {
    0x00: 'SF12',
    0x01: 'SF11',
    0x02: 'SF10',
    0x03: 'SF9',
    0x04: 'SF8',
    0x05: 'SF7'
};

const STATE = {
    0x00: 'STATUS_IDLE',
    0x01: 'STATUS_TXING',
    0x02: 'STATUS_TXDONE',
    0x03: 'STATUS_RXOPEN1',
    0x04: 'STATUS_RXDONE1',
    0x05: 'STATUS_RXOPEN2',
    0x06: 'STATUS_RXDONE2'
};

function parse(reader) {
    reader.readUInt8('data.params.ucp_version');
    reader.readUInt32LE("data.timestamp", timeFilter);
    reader.readUInt8('data.params.snr');
    reader.readUInt16LE('data.params.rssi');
    reader.readUInt8('data.params.join_status', value => value === 1);
    reader.readUInt8('data.params.chan');
    reader.readUInt8('data.params.data_rate', value => RATE[value]);
    reader.readUInt8('data.params.rx_2_dr', value => RATE[value]);
    reader.readUInt32LE('data.params.rx_2_freq');
    reader.readUInt8('data.params.max_EIRP');
    reader.readUInt32LE('data.params.receive_delay_1');
    reader.readUInt32LE('data.params.receive_delay_2');
    reader.readUInt8('data.params.cur_retry_counts');
    reader.readUInt8('data.params.status', value => STATE[value]) ;
    reader.readUInt32LE('data.params.cur_up_link_counter');
    reader.readUInt32LE('data.params.cur_down_link_counter');
    reader.readUInt8('data.params.di_input');
    reader.readUInt8('data.params.di_output');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/device-status-parser.js